const emitterSingleton = {
  _instance: null,
  get instance () {
    if (!this._instance) {
      this._instance = {
        _emitter: null,
        get emitter () {
          return this._emitter
        },
        set emitter (value) {
          this._emitter = value
        }
      }
    }
    return this._instance
  }
}

export {
  emitterSingleton
}



// WEBPACK FOOTER //
// ./src/graph_parts/emitter.js